import { checkAccessToPath } from 'frontend/common/access-helpers'
import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { computed } from 'vue'

export function useOperationalModulesSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }
  const section = computed(() => {
    const result = {
      name: 'Operational Modules',
      sectionType: ResourceSectionType.OperationalModules,
      items: [
        {
          title: 'Dispatcher',
          isDisabled: false,
          path: 'dispatcher-screen',
          icon: 'mi-outlined mi-settings-input-component',
        },
        {
          title: 'Shifts Manager',
          isDisabled: false,
          path: 'shifts-manager-screen',
          icon: 'mi-outlined mi-groups',
        },
        {
          title: 'Live Panel',
          isDisabled: false,
          path: 'live-panel',
          icon: 'mi-outlined mi-satellite',
        },
        {
          title: 'Client Communication',
          isDisabled: false,
          path: 'client-communication',
          icon: 'mi-outlined mi-textsms',
        },
        {
          title: 'System Notifications',
          isDisabled: false,
          path: 'system-notifications',
          icon: 'mi-outlined mi-notification-important',
        },
        {
          title: 'Bus Module',
          isDisabled: false,
          path: 'bus-module',
          icon: 'mi-outlined mi-directions-bus',
        },
      ],
    }
    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
